import { createUseStyles } from 'react-jss';
import { mediaQuery, ITheme } from '@quicktools/shared-components/styles';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginBottom: 12,
      textAlign: 'center',
    },
    heading: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: '32px',
      marginBottom: 4,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 20,
        lineHeight: '28px',
      },
    },
    icon: {
      fill: 'var(--x-accent-2-1)',
      height: 16,
      marginLeft: 4,
      width: 16,

      [mediaQuery(breakpoints.tablet)]: {
        height: 20,
        width: 20,
      },
    },
    link: {
      alignItems: 'center',
      color: 'var(--x-accent-2-1)',
      display: 'flex',
      fontSize: 20,
      fontWeight: 500,
      justifyContent: 'center',
      lineHeight: '28px',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 14,
        lineHeight: '20px',
      },
    },
  }),
  { name: 'SeeAllFonts' },
);
